import React from 'react';
import ToggleAccordion from './ToggleAccordion';

interface BCPGuideSectionProps {
  guideContent?: React.ReactNode;
  exampleContent?: React.ReactNode;
  children?: React.ReactNode;
}

const BCPGuideSection: React.FC<BCPGuideSectionProps> = ({ guideContent, exampleContent, children }) => {
  // If children is provided, use the new single-section format
  if (children) {
    return (
      <div className="mb-6">
        <div
          style={{
            width: '100%',
            gap: '8px',
            backgroundColor: '#F5F5F5',
            borderLeft: '4px solid #0D357F',
            borderRadius: '8px',
            paddingTop: '8px',
            paddingRight: '16px',
            paddingBottom: '8px',
            paddingLeft: '20px',
          }}
        >
          <div style={{ fontSize: '14px', lineHeight: '20px', color: '#4B5563' }}>
            {children}
          </div>
        </div>
      </div>
    );
  }

  // Otherwise, use the two-section format
  return (
    <div className="mb-6">
      <ToggleAccordion title="記入ガイドを表示" defaultOpen={false}>
        <div
          style={{
            width: '100%',
            gap: '8px',
            backgroundColor: '#F5F5F5',
            borderLeft: '4px solid #0D357F',
            borderRadius: '8px',
            paddingTop: '8px',
            paddingRight: '16px',
            paddingBottom: '8px',
            paddingLeft: '20px',
          }}
        >
          <div style={{ fontSize: '14px', lineHeight: '20px', color: '#4B5563' }}>
            {guideContent}
          </div>

          <div className="mt-2">
            {exampleContent}
          </div>
        </div>
      </ToggleAccordion>
    </div>
  );
};

export default BCPGuideSection;
